interface LeaveDirectRoomDeps {
    readonly leaveRoom: () => Promise<void>;
    readonly onLeft: () => Promise<void>;
    readonly onLeaveFailed: (error: unknown) => void;
}

export async function leaveDirectRoom(deps: LeaveDirectRoomDeps): Promise<void> {
    try {
        await deps.leaveRoom();
    } catch (error) {
        deps.onLeaveFailed(error);
        return;
    }

    await deps.onLeft();
}
